<template>
  <label class="radio">
    <input type="radio"
           :checked="shouldBeChecked"
           :value="value"
           @change="updateInput">
    <div class="radio__dummy">
      <base-material-design-icon
        v-if="shouldBeChecked"
        icon="check"
      />
    </div>
  </label>
</template>

<script>
/**
   * stylized radio button widget
   */
export default {
  name: 'BaseRadioCheckBox',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    value: String,
    modelValue: {
      default: ''
    }
  },
  computed: {
    shouldBeChecked () {
      return this.modelValue === this.value
    }
  },
  methods: {
    updateInput () {
      this.$emit('change', this.value)
    }
  }
}
</script>

<style scoped lang="scss">
.radio {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  user-select: none;
  cursor: pointer;

  input {
    display: none;

    &:checked {
      & + div {
        color: $rfx-bright-blue;

        div {
          background-color: currentColor;
        }

        & + span {
          font-weight: bold;
          color: $rfx-dark-march;
        }
      }
    }
  }

  &__dummy {
    /*display: flex;*/
    width: 18px;
    height: 18px;
    flex: 0 0 18px;
    color: $rfx-silver;
    border: 2px solid currentColor;
    position: relative;

    span {
      top: -2px;
      left: -2px;
      color: $rfx-bright-blue;
      position: absolute;
    }
  }
}
</style>
